import React, { Component } from "react"
import { Auth } from 'aws-amplify'

class Perfil extends Component {
    constructor(props) {
        super(props)
        this.state = {
            username: '',
            name: '',
            mail: '',
            isLoading: true,
            hasError: false,
            notification: '',
            cambiarPass: false,
            oldPass: '',
            oldPassError: '',
            oldPassHasError: false,
            newPass: '',
            newPassError: '',
            newPassHasError: false,
            checkNewPass: '',
            checkNewPassError: '',
            checkNewPassHasError: false
        }
        this.handleChange = this.handleChange.bind(this)
        this.changePassword = this.changePassword.bind(this)
    }

    changePassword() {
        if (this.state.checkNewPass === this.state.newPass && this.state.oldPass.length > 0 && 
            this.state.checkNewPass.length > 0 && this.state.newPass.length > 0) {
            Auth.currentAuthenticatedUser()
                .then(user => {
                    return Auth.changePassword(user, this.state.oldPass, this.state.newPass)
                })
                .then(data => {
                    this.setState({
                        notification: (
                            <div className='alert alert-success'>
                                La contraseña se actualizo correctamente
                            </div>
                        ),
                        oldPass: '',
                        newPass: '',
                        checkNewPass: '',
                        cambiarPass: false
                    })
                })
                .catch(error => {
                    console.log(error)
                    this.setState({
                        notification: (
                            <div className='alert alert-danger'>
                                {
                                    (error.code === 'NotAuthorizedException') ? 'La contraseña es incorrecta' : error.message
                                }
                            </div>
                        )
                    })
                })
        } else {
            if (this.state.checkNewPass !== this.state.newPass) {
                this.setState({
                    newPassError: 'Las contraseñas nuevas no coinciden',
                    newPassHasError: true,
                    checkNewPassError: 'Las contraseñas nuevas no coinciden',
                    checkNewPassHasError: true
                })
            }
            if (this.state.oldPass.length === 0) {
                this.setState({
                    oldPassError: 'La contraseña actual es requerida',
                    oldPassHasError: true
                })
            }
            if (this.state.newPass.length === 0) {
                this.setState({
                    newPassError: 'La contraseña nueva es requerida',
                    newPassHasError: true
                })
            }
            if (this.state.checkNewPass.length === 0) {
                this.setState({
                    checkNewPassError: 'Deves volver a ingresar tu contraseña nueva',
                    checkNewPassHasError: true
                })
            }
        }
    }

    handleChange(e) {
        this.setState({
            oldPass: (e.target.id === 'oldpass') ? e.target.value : this.state.oldPass,
            newPass: (e.target.id === 'newPass') ? e.target.value : this.state.newPass,
            checkNewPass: (e.target.id === 'checkNewPass') ? e.target.value : this.state.checkNewPass,

            oldPassError: (e.target.id === 'oldpass' && e.target.value.length === 0) ? 'La contraseña actual es requerida' : this.state.oldPassError,
            oldPassHasError: (e.target.id === 'oldpass') ? (e.target.value.length === 0) :  this.state.oldPassHasError,

            newPassError: (e.target.id === 'newPass' && e.target.value.length === 0) ? 'La contraseña nueva es requerida' : this.state.newPassError,
            newPassHasError: (e.target.id === 'newPass') ? (e.target.value.length === 0) :  this.state.newPassHasError,

            checkNewPassError: (e.target.id === 'checkNewPass' && e.target.value.length === 0) ? 'Deves volver a ingresar tu contraseña nueva' : this.state.checkNewPassError,
            checkNewPassHasError: (e.target.id === 'checkNewPass') ? (e.target.value.length === 0) :  this.state.checkNewPassHasError,
        })
    }

    async componentDidMount() {
        try {
            let user = await Auth.currentAuthenticatedUser()
            const {
                attributes
            } = user
            this.setState({
                username: user.username,
                name: attributes.name,
                mail: attributes.email,
                isLoading: false
            })
        } catch (e) {
            this.setState({
                hasError: true,
                notification: (
                    <div className='alert alert-danger'>
                        Hubo un error obteniendo su informacion
                    </div>
                )
            })
        }
    }

    render() {
        let profile_info = (
            <div>
                <div className='row mt-5'>
                    <div className='col-md-12'>
                        {this.state.notification}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <h1>
                            <p className='text-center'>
                                Mi perfil
                            </p>
                        </h1>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-md-4'>
                        <strong>Nombre: </strong>
                    </div>
                    <div className='col-md-8'>
                        {this.state.name}
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-md-4'>
                        <strong>Nombre de usuario: </strong>
                    </div>
                    <div className='col-md-8'>
                        {this.state.username}
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-md-4'>
                        <strong>Correo electronico: </strong>
                    </div>
                    <div className='col-md-8'>
                        {this.state.mail}
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-md-12'>
                        <button type="button" className="btn btn-primary float-right" onClick={() => this.setState({cambiarPass: true, notification: ''})}>
                            Cambiar contraseña
                        </button>
                    </div>
                </div>
            </div>
        )
        let changePassword = (
            <div>
                <div className='row mt-5'>
                    <div className='col-md-12'>
                        <h1>
                            <p className='text-center'>
                                Mi perfil
                            </p>
                        </h1>
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col-md-12'>
                        {this.state.notification}
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label htmlFor='oldpass'>Contraseña actual</label>
                            <input type='password' className={'form-control' + ((this.state.oldPassHasError) ? ' is-invalid' : '')} id='oldpass' aria-describedby='oldpass-help' value={this.state.oldPass} onChange={this.handleChange} />
                            <small id='oldpass-help' className='form-text text-danger'>{(this.state.oldPassHasError) ? this.state.oldPassError : ''}</small>
                        </div>
                        <div className='form-group'>
                            <label htmlFor='newPass'>Contraseña nueva</label>
                            <input type='password' className={'form-control' + ((this.state.newPassHasError) ? ' is-invalid' : '')} id='newPass' aria-describedby='newPass-help' value={this.state.newPass} onChange={this.handleChange} />
                            <small id='newPass-help' className='form-text text-danger'>{(this.state.newPassHasError) ? this.state.newPassError : ''}</small>
                        </div>
                        <div className='form-group'>
                            <label htmlFor='checkNewPass'>Verifica tu contraseña</label>
                            <input type='password' className={'form-control' + ((this.state.checkNewPassHasError) ? ' is-invalid' : '')} id='checkNewPass' aria-describedby='checkNewPass-help' value={this.state.checkNewPass} onChange={this.handleChange} />
                            <small id='checkNewPass-help' className='form-text text-danger'>{(this.state.checkNewPassHasError) ? this.state.checkNewPassError : ''}</small>
                        </div>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-md-12'>
                        <button type="button" className="btn btn-secondary float-left" onClick={() => this.setState({cambiarPass: false, notification: ''})}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-primary float-right" onClick={this.changePassword}>
                            Actualizar contraseña
                        </button>
                    </div>
                </div>
            </div>
        )
        if (this.state.isLoading) 
            return (
                <h4 className='mt-3'>
                    <p className='text-center'>
                        Cargando...
                    </p>
                </h4>
            )
        return this.state.cambiarPass ? changePassword : profile_info
    }
}

export default Perfil